import * as Yup from "yup";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
// form
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
// @mui
import { Stack, Card } from "@mui/material";
import { LoadingButton } from "@mui/lab";
// components
import { FormProvider, RHFTextField } from "../../../../components/hook-form";
import useAuth from "../../../../hooks/useAuth";
import axios from "../../../../utils/axios";

// ----------------------------------------------------------------------

export default function AccountChangePassword() {
  const { refresh } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const ChangePassWordSchema = Yup.object().shape({
    oldPassword: Yup.string().required("Old Password is required"),
    newPassword: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("New Password is required"),
    confirmNewPassword: Yup.string().oneOf(
      [Yup.ref("newPassword"), null],
      "Passwords must match"
    ),
  });

  const defaultValues = {
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  };

  const methods = useForm({
    resolver: yupResolver(ChangePassWordSchema),
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    try {
      const response = await axios.put(
        "/api/v1/accounts/update-password",
        data
      );
      reset();
      enqueueSnackbar(response.data);
      refresh();
    } catch (error) {
      console.error(error);
      enqueueSnackbar(error.response.data, { variant: "error" });
    }
  };

  return (
    <Card sx={{ p: 3 }}>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={3} alignItems="flex-end">
          <RHFTextField
            name="oldPassword"
            type="password"
            label={t("params.oldpassword")}
          />

          <RHFTextField
            name="newPassword"
            type="password"
            label={t("params.newpassword")}
          />

          <RHFTextField
            name="confirmNewPassword"
            type="password"
            label={t("params.confpassword")}
          />

          <LoadingButton
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            {t("params.save")}
          </LoadingButton>
        </Stack>
      </FormProvider>
    </Card>
  );
}
